import { combineReducers, createStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import * as moment from 'moment';

import calendarReducer from './reducers/calendar.reducer';
import { ICalendarState, ICalendarSettings, defaultCalendarSettings } from '../classes/calendar';
import { ICalendarAppText } from '../custom/classes/calendar-text';
import { IEvent } from '../custom/classes/event';
import { eventsUpdated } from './actions/calendar.actions';

import calendarSettingsReducer from './reducers/calendar-settings.reducer';
import { getEventsFromApi, getText } from './actions/calendar-api.actions';
import calendarTextReducer from './reducers/calendar-text.reducer';
import { IPromoCodeState } from '../classes/promo-code';
import promoCodeReducer from './reducers/promo-code.reducer';
import { receiveText } from './actions/calendar-text.actions';
import { ILazyLoadState } from '../classes/lazy-load';
import lazyLoadReducer from './reducers/lazy-load.reducer';
import { GetFilterFromQuery, AddFilterToQuery } from '../helpers/filter-by-query';
import { updateCalendarSettings } from './actions/calendar-settings.actions';
declare const lastDate: string;
declare const pageData: string;
declare const promoCode: string;
const lastDateMoment = moment(lastDate);

export interface ICalendarAppState {
    calendar: ICalendarState<IEvent>;
    calendarSettings: ICalendarSettings;
    calendarText: ICalendarAppText;
    promoCode: IPromoCodeState;
    lazyLoad: ILazyLoadState;
}

const appReducer = combineReducers({
    calendar: calendarReducer,
    calendarSettings: calendarSettingsReducer,
    calendarText: calendarTextReducer,
    promoCode: promoCodeReducer,
    lazyLoad: lazyLoadReducer
});

// Calculate the months that are valid on the calendar.
let monthsOnCalendar: moment.Moment[] = [];

for (let i = moment().clone().startOf("month"); i.isSameOrBefore(lastDateMoment.endOf("month")); i.add(1, "month")) {
    monthsOnCalendar.push(i.clone());
}

let calendarSettings = {
    ...defaultCalendarSettings,
    monthsOnCalendar: monthsOnCalendar
};

const appStore = createStore(appReducer, {
    calendarSettings: calendarSettings
}, applyMiddleware(thunk));


//if (window.location.search.length > 1) {
//    GetFilterFromQuery(window.location.search, appStore);
//}

// redux-thunk messes with redux typings.
appStore.dispatch(getEventsFromApi() as any);

appStore.dispatch(receiveText(pageData as any));

appStore.dispatch(updateCalendarSettings(JSON.parse(promoCode)) as any);

let prevState = appStore.getState();

appStore.subscribe(() => {
    const currState = appStore.getState();

    const apiUpdate = !prevState.calendar.startDate.isSame(currState.calendar.startDate) || !prevState.calendar.endDate.isSame(currState.calendar.endDate);

    // If the event references are completely different, re-calculate them.
    if (apiUpdate || (currState.calendar.updating && prevState.calendar.events !== currState.calendar.events)) {
        prevState = appStore.getState();

        appStore.dispatch(getEventsFromApi() as any);
    }
});

export { appStore };